import React, { useState, useEffect } from "react";
import { TextField, Button, Box, Typography } from "@mui/material";
import defaultConfigData from "./config/defaultConfigData";
import { useSnackbar } from "../components/snackbar/SnackbarProvider";

const ConfigEdit = () => {
    const snackbar = useSnackbar();
    const [jsonData, setJsonData] = useState(null);
    const [editedData, setEditedData] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = defaultConfigData;
                setJsonData(response);
                setEditedData(response);
            } catch (error) {
                console.error("Ошибка загрузки JSON:", error);
            }
        };
        fetchData();
    }, []);

    // Обновление редактируемых полей
    const handleFieldChange = (tabIndex, field, value) => {
        const updatedData = { ...editedData };
        updatedData.settings.Tabs[tabIndex][field] = value;
        setEditedData(updatedData);
    };

    const handleTextLineChange = (tabIndex, pageIndex, lineIndex, value) => {
        const updatedData = { ...editedData };
        updatedData.settings.Tabs[tabIndex].Pages[pageIndex].TextLines[lineIndex] =
            value;
        setEditedData(updatedData);
    };

    // Сохранение изменений
    const saveChanges = async () => {
        try {
            console.log(editedData)
            snackbar.success("Изменения сохранены!");
        } catch (error) {
            console.error("Ошибка сохранения JSON:", error);
            snackbar.error("Не удалось сохранить изменения.");
        }
    };

    /*if (!jsonData || !editedData) {
        return <Typography>Загрузка...</Typography>;
    }*/

    return (
        <Box p={2}>
            {editedData && editedData.settings.Tabs.map((tab, tabIndex) => (
                <Box key={tabIndex} mb={4}>
                    <Typography variant="h6">Tab {tabIndex + 1}</Typography>
                    <TextField
                        label="ButtonText"
                        fullWidth
                        value={tab.ButtonText}
                        onChange={(e) =>
                            handleFieldChange(tabIndex, "ButtonText", e.target.value)
                        }
                        sx={{ mb: 2 }}
                    />
                    <TextField
                        label="HeaderText"
                        fullWidth
                        value={tab.HeaderText}
                        onChange={(e) =>
                            handleFieldChange(tabIndex, "HeaderText", e.target.value)
                        }
                        sx={{ mb: 2 }}
                    />
                    {tab.Pages.map((page, pageIndex) => (
                        <Box key={pageIndex} mb={2}>
                            <Typography variant="subtitle1">
                                Страница {pageIndex + 1}
                            </Typography>
                            {page.TextLines.map((line, lineIndex) => (
                                <TextField
                                    key={lineIndex}
                                    label={`TextLine ${lineIndex + 1}`}
                                    fullWidth
                                    multiline
                                    value={line}
                                    onChange={(e) =>
                                        handleTextLineChange(
                                            tabIndex,
                                            pageIndex,
                                            lineIndex,
                                            e.target.value
                                        )
                                    }
                                    sx={{ mb: 1 }}
                                />
                            ))}
                        </Box>
                    ))}
                </Box>
            ))}
            <Button variant="contained" color="primary" onClick={saveChanges}>
                Сохранить
            </Button>
        </Box>
    );
}

export default ConfigEdit;